export default __webpack_public_path__ + "static/ph-6-6-sale-subbanner-desktop-866a10bb295376a7964936d1b34f623f.webp";